import React from 'react';

import { ISelectProps } from './types';
import Box from 'v2/components/UI/Box';

import * as SC from './styles';
import Text from '../UI/Text';
const Select: React.FC<ISelectProps> = ({
  options,
  onChange,
  value,
  label,
  labelId,
  selectId,
  width,
  maxWidth,
  backgroundColor,
  errorMessage,
  valueBlocked,
  exibitValueBlocked,
  borderRadius = '16px',
  colorLabel = '#1c4d1e',
  ...rest
}) => {
  const optionsValues =
    valueBlocked && exibitValueBlocked
      ? [{ id: '0', label: valueBlocked, value: 0 }]
      : options;

  const valueSelected = valueBlocked && exibitValueBlocked ? 0 : value;

  const renderErrorMessage = () => {
    if (
      errorMessage &&
      options.length > 1 &&
      !valueBlocked &&
      !exibitValueBlocked
    ) {
      return (
        <Box>
          <Text color="#f44336" fontWeight={500}>
            {errorMessage}
          </Text>
        </Box>
      );
    }
    return null;
  };
  return (
    <Box
      flexDirection="column"
      width={width}
      maxWidth={maxWidth}
      borderRadius={borderRadius}
    >
      <Text color={colorLabel} fontWeight={500}>
        {label}
      </Text>
      <SC.Select
        labelId={labelId}
        id={selectId}
        value={valueSelected}
        disabled={options.length === 0 || options.length === 1}
        onChange={onChange}
        backgroundColor={backgroundColor}
        width={width}
        maxWidth={maxWidth}
        borderRadius={borderRadius}
        errorMessage={
          options.length > 1 && !valueBlocked && !exibitValueBlocked
            ? errorMessage
            : undefined
        }
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            sx: {
              borderRadius: 4,
              boxShadow: '0 -5px 10px #0d86ff3b , 0 5px 30px #44d78961 ',
              mt: 0.5,
            },
          },
          MenuListProps: {
            disablePadding: true,
          },
        }}
        {...rest}
      >
        {optionsValues.map(({ id, label, value }, index) => (
          <SC.MenuItem
            key={id}
            value={value}
            pair={index % 2 === 0}
            width={width}
            maxWidth={maxWidth}
          >
            {label}
          </SC.MenuItem>
        ))}
      </SC.Select>
      {renderErrorMessage()}
    </Box>
  );
};

export default Select;
